import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";

import URL from "./common/variables";

import Auth from "./components/Auth/Auth";
import Maps from "./components/Maps/Maps";
import Bookmarks from "./components/Bookmarks/Bookmarks";
import Search from "./components/Search/Search";
import Logout from "./components/Logout/Logout";
import WelcomeUser from "./components/WelcomeUser/WelcomeUser";
import Poll from './components/Poll/Poll.jsx';
import TTSControl from './components/TTSControl/TTSControl.jsx';
import { getUrlParameter } from "./common/functions";

const App = () => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    axios
      .get(`${URL}/rest-auth/user/`)
      .then(() => true) // Return something without errors.
      .catch((err) => {
        if (err.response.status === 403) {
          setIsLogin(true);
        }
      });
  }, []);

  if (isLogin) {
    return <Auth withoutCookies />;
  }

  if (
    getUrlParameter("type") === "password-reset" &&
    getUrlParameter("uid") &&
    getUrlParameter("token")
  ) {
    return <Auth isPasswordReset />;
  }

  if (getUrlParameter("type") === "logout") {
    return <Logout />;
  }

  return (
    <>
      <Auth>
        <WelcomeUser />
      </Auth>
    </>
  );
};

function inyectComponent(component, selector) {
  const element = document.querySelector(selector);

  if (element !== null) {
    ReactDOM.render(component, element);
  }
}

const components = [
  [<App />, "#app"],
  [<Bookmarks />, '#bookmarks'],
  [<Search />, '.search'],
  [<Maps />, '#map'],
  [<Poll />, '.poll'],
  [<TTSControl />, '.tts-control'],
];

components.forEach((tuple) => {
  const [component, selector] = tuple;

  inyectComponent(component, selector);
});
